import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
`;

export const LoadingArea = styled.div`
  margin-bottom: 12px;
`;

export const Header = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Filters = styled.div`
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: 150px 220px 120px 160px 132px;
  max-width: 864px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
    max-width: none;
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const Detail = styled.div`
  background: #f7f9fb;
  border-top: 1px solid #dfe5ec;
  padding: 16px;
`;

export const Fields = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin-bottom: 12px;
`;

export const Sections = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(280px, 1fr));

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.div`
  border-top: 1px solid #dfe5ec;
  padding-top: 12px;
`;

export const SectionTitleRow = styled.div`
  align-items: baseline;
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
`;

export const ConfirmLink = styled.button`
  background: transparent;
  border: 0;
  color: #1976d2;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: #0d47a1;
  }
`;

export const SectionTitle = styled(Typography).attrs({ variant: 'subtitle2' })`
  && {
    color: #334155;
    font-weight: 600;
    margin-bottom: 0;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 12px;
`;
